import { render, staticRenderFns } from "./ChannelEditForm.vue?vue&type=template&id=e39e3fda&"
import script from "./ChannelEditForm.vue?vue&type=script&lang=ts&"
export * from "./ChannelEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelEditForm.vue?vue&type=style&index=0&id=e39e3fda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports